<template>
  <div id="permissionDialog">
    <el-dialog :title="title" width="540px" :visible.sync="isVisibleTemp" @close="closeAndclear('permInfo')">
      <el-form :model="permInfo" :rules="rules" ref="permInfo">
        <el-form-item label="U权限编码" :label-width="formLabelWidth" prop="permCode">
          <el-input class="eb-input panel-body-row-right" v-model="permInfo.permCode" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="权限名称" :label-width="formLabelWidth" prop="permName">
          <el-input class="eb-input panel-body-row-right" v-model="permInfo.permName" auto-complete="off" placeholder="权限名称"></el-input>
        </el-form-item>
        <el-form-item label="权限URL" :label-width="formLabelWidth" prop="permUrl">
          <el-input class="eb-input panel-body-row-right" v-model="permInfo.permUrl" auto-complete="off" placeholder="权限URL"></el-input>
        </el-form-item>
        <el-form-item label="权限描述" :label-width="formLabelWidth" prop="permDesc">
          <el-input type="textarea" class="eb-textarea" :rows="2" v-model="permInfo.permDesc" auto-complete="off" placeholder="权限描述"></el-input>
        </el-form-item>
        <el-form-item label="权限类型" :label-width="formLabelWidth" prop="dassiontapermi">
          <el-radio-group v-model="permInfo.dassiontapermi">
            <el-radio label="0">菜单</el-radio>
            <el-radio label="1">按钮</el-radio>
            <el-radio label="2">URL</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开发人员" :label-width="formLabelWidth" prop="authorName">
          <el-select v-model="permInfo.authorName" clearable placeholder="请选择开发人员">
            <el-option label="张书达" value="张书达"></el-option>
            <el-option label="韩艳苹" value="韩艳苹"></el-option>
            <el-option label="陈汉卿" value="陈汉卿"></el-option>
            <el-option label="付胜利" value="付胜利"></el-option>
            <el-option label="王鹏飞" value="王鹏飞"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="closeAndclear('permInfo')">关闭</el-button>
        <el-button v-if="permInfo.operType === 'add'" class="eb-button-group-btn eb-button-orange eb-button-big" @click="addPermission">确定</el-button>
        <el-button v-else class="eb-button-group-btn eb-button-orange eb-button-big" @click="editPermission">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { addPermission, editPermission } from '@/services/system-service';
export default {
  props: {
    permInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      formLabelWidth: '120px',
      rules: {
        permName: [{ required: true, message: '请输入权限名称', trigger: 'blur' }],
        permUrl: [{ required: true, message: '请输入权限URL', trigger: 'blur' }],
        authorName: [{ required: true, message: '请输选择开发人员', trigger: 'blur' }],
        dassiontapermi: [{ required: true, message: '请输选择权限类型', trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      if (this.permInfo.operType === 'add') {
        return '新增权限';
      } else {
        return '修改权限';
      }
    },
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    // 保存
    addPermission() {
      this.$refs['permInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await addPermission(this.permInfo);
            if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('添加成功');
              this.$emit('onSuccess');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    editPermission() {
      this.buttonLoading = true;
      this.$refs['permInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          try {
            let { data } = await editPermission(this.permInfo);
            if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('修改成功');
              this.$emit('onSuccess');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    closeAndclear(permInfo) {
      this.isVisibleTemp = false;
      this.$refs[permInfo].resetFields();
    }
  }
};
</script>
<style lang="less">
#permissionDialog {
  .dialog-footer {
    text-align: center;
  }
}
</style>
